module.exports = __webpack_public_path__ + "static/media/close.0b01d709.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/couponspa/close.png
// module id = 1916
// module chunks = 6